const EVERY_PAGE_VARIABLES = [
	'aa_account',
	'site_template',
	'page_language',
	'page_name',
	'property_code',
	'property_name',
	'property_region',
	'user_type',
	'golden_id',
	'login_state',
] as const;

export default function getEveryPageAnalyticsVariables(): Record<string, unknown> {
	const pageData = typeof window === 'undefined' ? undefined : window.utag_data;
	const inheritedVariables = Object.fromEntries(
		EVERY_PAGE_VARIABLES.flatMap(variable =>
			pageData?.[variable] === undefined ? [] : [[variable, pageData[variable]]]
		)
	);

	return {
		...inheritedVariables,
	};
}
